import script from "./PageContainerFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContainerFooter.vue?vue&type=script&setup=true&lang=js"

import "./PageContainerFooter.vue?vue&type=style&index=0&id=e667dde6&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./PageContainerFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e667dde6"]])

export default __exports__